import * as loadingState from '@blueberry/constants/loadingState';
import {
  MATERY,
  ASSESSMENT,
  STUDENT,
  STUDENT_SCORE_RECORD,
} from '@blueberry/constants/dashboardRouting';

import * as actions from './actions';

const initialState = {
  studentListLoadingStatus: loadingState.EMPTY,
  studentScoresLoadingStatus: loadingState.EMPTY,
  masteryLoadingStatus: loadingState.EMPTY,
  masteryDetailLoadingStatus: loadingState.EMPTY,
  assessmentLoadingStatus: loadingState.EMPTY,
  assessmentDetailLoadingStatus: loadingState.EMPTY,
  filterDataLoadingStatus: loadingState.EMPTY,
  masteryList: [],
  subtopicData: undefined,
  assessmentList: [],
  assessmentDetail: undefined,
  studentList: [],
  schoolClasses: [],
  semesters: [],
  subjects: [],
  selectedClassIndex: 0,
  selectedSemesterIndex: 0,
  selectedSubjectIndex: 0,
  currentPage: MATERY,
  currentStudentId: 0,
  filterConditions: undefined,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_DROP_DOWN_DATA:
      return {
        ...initialState,
        filterDataLoadingStatus: loadingState.LOADING,
      };
    case actions.FETCH_DROP_DOWN_DATA_SUCCESS:
      return {
        ...state,
        filterDataLoadingStatus: loadingState.READY,
        schoolClasses: action.payload.schoolClasses,
        semesters: action.payload.semesters,
        subjects: action.payload.subjects,
      };
    case actions.CHANGE_CLASS_INDEX:
      return {
        ...state,
        selectedClassIndex: action.payload.index,
      };
    case actions.CHANGE_SEMESTER_INDEX:
      return {
        ...state,
        selectedSemesterIndex: action.payload.index,
      };
    case actions.CHANGE_SUBJECT_INDEX:
      return {
        ...state,
        selectedSubjectIndex: action.payload.index,
      };
    case actions.FETCH_MASTERY_PAGE_DATA:
      return {
        ...state,
        masteryLoadingStatus: loadingState.LOADING,
        currentPage: MATERY,
      };
    case actions.FETCH_MASTERY_PAGE_DATA_SUCCESS:
      return {
        ...state,
        masteryLoadingStatus: loadingState.READY,
      };
    case actions.FETCH_MASTERY_DATA:
      return {
        ...state,
        masteryLoadingStatus: loadingState.LOADING,
      };
    case actions.FETCH_MASTERY_DATA_SUCCESS:
      return {
        ...state,
        masteryLoadingStatus: loadingState.READY,
        masteryList: action.payload.data,
      };
    case actions.FETCH_MASTERY_DETAIL_DATA:
      return {
        ...state,
        masteryDetailLoadingStatus: loadingState.LOADING,
      };
    case actions.FETCH_MASTERY_DETAIL_DATA_SUCCESS:
      return {
        ...state,
        masteryDetailLoadingStatus: loadingState.READY,
        subtopicData: action.payload.data,
      };
    case actions.FETCH_ASSESSMENT_PAGE_DATA:
      return {
        ...state,
        assessmentLoadingStatus: loadingState.LOADING,
        currentPage: ASSESSMENT,
      };
    case actions.FETCH_ASSESSMENT_PAGE_DATA_SUCCESS:
      return {
        ...state,
        assessmentLoadingStatus: loadingState.READY,
      };
    case actions.FETCH_ASSESSMENT_LIST_DATA:
      return {
        ...state,
        assessmentLoadingStatus: loadingState.LOADING,
      };
    case actions.FETCH_ASSESSMENT_LIST_DATA_SUCCESS:
      return {
        ...state,
        assessmentLoadingStatus: loadingState.READY,
        assessmentList: action.payload.assessmentList,
      };
    case actions.FETCH_ASSESSMENT_DETAIL_DATA:
      return {
        ...state,
        assessmentDetailLoadingStatus: loadingState.LOADING,
      };
    case actions.FETCH_ASSESSMENT_DETAIL_DATA_SUCCESS:
      return {
        ...state,
        assessmentDetailLoadingStatus: loadingState.READY,
        assessmentDetail: action.payload.assessmentDetail,
      };
    case actions.FETCH_STUDENT_PAGE_DATA:
      return {
        ...state,
        studentListLoadingStatus: loadingState.LOADING,
        currentPage: STUDENT,
      };
    case actions.FETCH_STUDENT_PAGE_DATA_SUCCESS:
      return {
        ...state,
        studentListLoadingStatus: loadingState.READY,
      };
    case actions.FETCH_STUDENT_LIST_DATA:
      return {
        ...state,
        studentListLoadingStatus: loadingState.LOADING,
      };
    case actions.FETCH_STUDENT_LIST_DATA_SUCCESS:
      return {
        ...state,
        studentListLoadingStatus: loadingState.READY,
        studentList: action.payload.studentList,
      };
    case actions.FETCH_STUDENT_SCORE_PAGE_DATA:
      return {
        ...state,
        studentScoresLoadingStatus: loadingState.LOADING,
        currentPage: STUDENT_SCORE_RECORD,
        currentStudentId: action.payload.studentId,
      };
    case actions.FETCH_STUDENT_SCORE_PAGE_DATA_SUCCESS:
      return {
        ...state,
        studentScoresLoadingStatus: loadingState.READY,
      };
    case actions.SAVE_FILTER_CONDITION:
      return {
        ...state,
        filterConditions: action.payload,
      };
    case actions.CLEAR_FILTER_CONDITION:
      return {
        ...state,
        filterConditions: initialState.filterConditions,
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./app/redux/tutorDashboard/reducer.js